@if (isOpen) {
  <div class="pdf-float-modal full-h" [ngClass]="{'fullscreen':fullscreen}">
    <div class="border-bottom p-2 bg-info d-flex justify-content-between" style="cursor: move" floatDialog
      target=".pdf-float-modal" [disabled]="fullscreen">
      <i class="bi cursor font-12 me-1" [ngClass]="fullscreen?'bi-fullscreen-exit':'bi-fullscreen'"
      (click)="fullscreen = !fullscreen; $event.stopPropagation()"></i>
      <i class="bi bi-x-lg cursor font-12 me-1" (click)="close()"></i>
    </div>
    <div class="h-100">
      @switch (showType) {
        @case ('pdf') {
          <iframe [showFile]="showHref" class="w-100 h-100" type="application/pdf"></iframe>
        }
        @case ('img') {
          <img [showFile]="showHref" class="w-100" />
        }
      }
    </div>
  </div>
}
